import React, {Component} from 'react'
import Select from 'react-select'
import InputUnitOfMeasure from '../../unit-of-measure/input.component.jsx'

class ConfigureAssemblyPart extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            initialChoice: null,
            choice: null,
            unit: '',
            hasCalculator: this.props.hasCalculator || false,
            measure: this.props.calculatedValue || '1',
            part: this.props.part,
            multi: this.props.part.attributes.type === "multiple",
            calculatedValue: this.props.calculatedValue
        }
        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback

        this.handleSelectChange = this.handleSelectChange.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.calculatedValue !== '###' &&
            nextProps.calculatedValue !== this.state.measure &&
            nextProps.calculatedValue !== this.state.calculatedValue) {
            this.setState({
                measure: nextProps.calculatedValue,
                calculatedValue: nextProps.calculatedValue,
            }, () => {
                this.partChanged()
            })
        }

        const choiceId = nextProps.partChoiceId || ''
        const measure = nextProps.measure || ''
        if (choiceId && this.state.initialChoice !== choiceId) {
            this.setState({
                initialChoice: choiceId,
                measure: measure,
            }, () => {
                const choices = this.state.part.attributes.choices.filter(
                    c => c.id === choiceId
                )
                if (choices.length > 0) {
                    this.handleSelectChange({
                        label: choices[0].attributes.product.attributes.title,
                        value: choices[0].id,
                    })
                }
            })
        }

    }

    handleSelectChange(choice) {
        let unitOfMeasure = ''
        if (choice) {
            unitOfMeasure = this.state.part.attributes.choices.filter(
                c => c.id === choice.value
            )[0].attributes.product.attributes.unitOfMeasure
        }
        this.setState({
            choice: choice,
            unit: unitOfMeasure,
        }, () => {
            this.partChanged()
        })
    }

    handleInputChange(measure) {
        this.setState({
            measure: measure,
        }, () => {
            this.partChanged()
        })
    }

    partChanged() {
        let price = '0'
        if (this.state.choice) {
            price = this.state.part.attributes.choices.filter(
                c => c.id === this.state.choice.value
            )[0].attributes.additionalUnitPrice
        }

        this.onChange({
            partId: this.state.part.id,
            additionalUnitPrice: price,
            partChoiceId: this.state.choice ? this.state.choice.value : '',
            measure: this.state.measure || '0',
        })
    }

    render() {
        const options = this.state.part.attributes.choices.map(c => {
            return {
                label: c.attributes.product.attributes.title,
                value: c.id,
            }
        })
        const required = this.state.part.attributes.required ? '*' : ''
        const unit = this.state.unit ?
            <InputUnitOfMeasure unit={this.state.unit} value={this.state.measure} onChange={this.handleInputChange} /> :
            ''

        let selectClasses = 'col-6'
        let unitGroup = <div className="col-3">
            {unit}
        </div>
        if (this.state.hasCalculator) {
            selectClasses = 'col-7'
            unitGroup = ''
        }

        return (
            <div className="form-row align-items-center form-group justify-content-end">
                <label className="col-3 text-align-right col-form-label">
                    {this.state.part.attributes.name} {required}
                </label>
                <div className={selectClasses}>
                    <Select
                        name={this.state.part.attributes.id + '_select'}
                        placeholder="Select part"
                        value={this.state.choice}
                        onChange={this.handleSelectChange}
                        options={options}
                    />
                </div>
                {unitGroup}
            </div>

        );
    }
}

export default ConfigureAssemblyPart





// WEBPACK FOOTER //
// ./src/common/pricing/add-item-modal/configureassemblypart.component.jsx